import { matchPath } from 'react-router';
import { PAGE_TITLES } from '../constants/Navigation';

export const getPageTitleFromUrl = (pathname) => {
	const currentPageTitle = Object.keys(PAGE_TITLES).find((key) => {
		if (matchPath({ path: key, exact: true, strict: false }, pathname)) {
			return true;
		}
		return false;
	});

	return PAGE_TITLES[currentPageTitle];
};
